import { AxiosError } from 'axios'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { Carrier, CarrierType } from 'src/api/models'
import { useForm, MapSelectField, TextField } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface CarrierProps {
  name: string
  carrier_type: CarrierType
}

const carrierSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  scac_code: yup.string().optional().label('SCAC Code'),
  carrier_type: yup.string().required().label('Type'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  carrier?: Carrier
}

export const CarrierDialog = (props: Props) => {
  const { open, handleClose, onSave, update, carrier } = props
  const classes = useStyles()

  const onSubmit = (data: CarrierProps) => {
    let func = skuit.sc.carriers.create
    let action = 'creat'
    if (update) {
      func = (data: CarrierProps) => skuit.sc.carriers.patch(carrier?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newCarrier: Carrier) => {
        handleClose()
        onSave?.()
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Carrier: ${newCarrier.name}`}
            newObject={newCarrier}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Carrier')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, data: formData } = useForm(carrierSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>{update ? 'Update' : 'Create'} Carrier</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            label="Name"
            defaultValue={carrier?.name}
          />
          <TextField
            name="scac_code"
            label="SCAC Code"
            defaultValue={carrier?.scac}
          />
          <MapSelectField
            name="carrier_type"
            label="Type"
            defaultValue={carrier?.carrierType || Carrier.Type.freight}
            options={Carrier.carrierTypeMap}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
